import { Box } from 'component/base/Grid';
import { ThemeColors } from 'providers/Theme';
import styled from 'styled-components';

import { AlertLevel, IAlert } from './types';

const map: Record<AlertLevel, ThemeColors> = {
  critical: 'deepRose',
  error: 'deepRose',
  warning: 'yellow',
  ok: 'softGreen',
  unknown: 'yellow',
  disabled: 'veryLightBlue',
};

export const AlertContainer = styled(Box)<IAlert>`
  color: ${(props) => props.theme.colors[map[props.level || 'error']]};
  background-color: ${(props) =>
    props.theme.colors[map[props.level || 'error']]}20;
  border-radius: 3px;
  text-align: left;
`;

AlertContainer.defaultProps = {
  my: 2,
  p: 1,
};
